<template>
  <div
    class="template-category-list-wrp"
    v-if="isCategoriesVisible"
  >
    <ul class="template-category-list">
      <li
        v-for="category in contentSlideTemplateCategories"
        :key="category.name"
        class="template-category-item"
        :class="{
          'active': selectingCategory.name === category.name
        }"
        @click="selectCategory(category)"
      >
        <span class="emoji">{{ category.emoji }}</span>
        <span class="name">{{ $i18nPresenter.t(category.name) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  computed: {
    ...mapGetters('contentSlideTemplates', ['contentSlideTemplateCategories', 'selectingCategory']),
    isCategoriesVisible() {
      return this.selectingCategory
    },
  },
  methods: {
    ...mapActions('contentSlideTemplates', ['selectContentSlideCategoryAction']),
    selectCategory(category) {
      this.selectContentSlideCategoryAction(category)
      util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Content slide > Select template category', category.name)
    },
  },
}
</script>

<style lang="scss" scoped>
.template-category-list-wrp {
  position: sticky;
  top: 0;
  z-index: 5;
  background: #fff;
  margin-left: -16px;
  padding-top: 8px;
  padding-bottom: 2px;
  margin-top: -12px;
}
.template-category-list {
  display: flex;
  padding: 0;
  flex-direction: row;
  margin-bottom: 6px;
  padding-left: 14px;
}
.template-category-item {
  display: flex;
  padding: 8px 12px;
  margin-right: 6px;
  flex-shrink: 0;
  width: 62px;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: stretch;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  &.active {
    background-color: #eff1f7;
  }
  &:hover {
    background-color: #eff1f7;
  }
  .emoji {
    font-size: 1.6em;
  }
  .name {
    font-size: 0.9em;
  }
}
</style>
